import { memoizeForATime } from 'helpers/memoize'

import { getNumber } from './getNumber'

const getColor = memoizeForATime((value: string | number | undefined) => {
  const parsedValue = getNumber(value)

  if (parsedValue >= 0) {
    return 'green'
  }

  return 'red'
})

export { getColor }
